import React from 'react';

import ObjectDisplay from 'components/ObjectDisplay'
const Details = props => {
  return (
    <div>
      <h3>Vacancy Details</h3>
      <ObjectDisplay object={props.selected}/>
    </div>
  );
};

import {initializer, selectors} from 'utils/resourcerizer';
import {connect} from 'react-redux';

import {VACANCIES_NS} from 'constants/index';

const vacancyInitializer = initializer(VACANCIES_NS)
const vacancySelectors = selectors(VACANCIES_NS)

const mstp = (state,ownProps) => ({
  selected: vacancySelectors.findOneById(state,ownProps.vacancyId)
})

Details.Container = vacancyInitializer(connect(mstp)(Details))

export default Details



// WEBPACK FOOTER //
// ./src/components/vacancies/Details.jsx